<div class="widget">
  <div class="body">
    <mat-drawer-container #drawerContainer class="body-widget-container">
      <mat-drawer-content>
        <div class="top-container">
          <div class="form-container">
            <div>
              <mat-checkbox class="example-margin" [(ngModel)]="enableWidget" (change)="toggleForm()">Enable Widget</mat-checkbox>
            </div>
            <form [formGroup]="form">
              <div class="property-section">
                <div class="form-row">
                  <mat-form-field appearance="fill" class="form-control">
                    <mat-label>Product Name</mat-label>
                    <input matInput id="productName" formControlName="productName">
                  </mat-form-field>
                  <div class="form-helper">
                    <div><code>productName: string</code> - The product name is used to identify the widget in the application.</div>
                  </div>
                </div>
                <div class="form-row">
                  <mat-form-field>
                    <mat-label>Widget Orientation</mat-label>
                    <mat-select id="orientation" formControlName="orientation">
                      @for (o of orientationOptions; track o) {
                        <mat-option id="{{o}}" [value]="o">{{ o }}</mat-option>
                      }
                      <mat-option value="">(Not Set)</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div class="form-helper">
                    <div><code>orientation: </code> - Define whether the Widget loads Automatically, Vertically or Horizontally.  If left unset, it will default to "Auto".</div>
                  </div>
                </div>
                <div formGroupName="featureFlags">
                  <h3>Feature Flags</h3>
                  <div class="form-helper">
                    <div><code>featureFlags: </code> - Object with a number of optional boolean properties to enable or disable various features.  If left unset all properties will default to enabled.</div>
                  </div>
                  <div class="form-row">
                    <tri-state-toggle formControlName="upload" labelUnset="Unset" labelTrue="Enabled" labelFalse="Disabled"></tri-state-toggle>
                    <div class="form-helper">
                      <div><code>upload: boolean</code> - Enable the upload feature in the widget.</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <tri-state-toggle formControlName="openInIpms" labelUnset="Unset" labelTrue="Enabled" labelFalse="Disabled"></tri-state-toggle>
                    <div class="form-helper">
                      <div><code>openInIpms: boolean</code> - Enable the "Open in IPMS" feature in the widget.</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <tri-state-toggle formControlName="workflowActions" labelUnset="Unset" labelTrue="Enabled" labelFalse="Disabled"></tri-state-toggle>
                    <div class="form-helper">
                      <div><code>workflowActions: boolean</code> - Enable the ability to perform workflow actions in the widget.</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <tri-state-toggle formControlName="documentPreview" labelUnset="Unset" labelTrue="Enabled" labelFalse="Disabled"></tri-state-toggle>
                    <div class="form-helper">
                      <div><code>documentPreview: boolean</code> - Enable the ability to preview documents in the widget.</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <tri-state-toggle formControlName="documentDownload" labelUnset="Unset" labelTrue="Enabled" labelFalse="Disabled"></tri-state-toggle>
                    <div class="form-helper">
                      <div><code>documentDownload: boolean</code> - Enable the ability to download documents in the widget.</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <tri-state-toggle formControlName="documentSendToAction" labelUnset="Unset" labelTrue="Enabled" labelFalse="Disabled"></tri-state-toggle>
                    <div class="form-helper">
                      <div><code>documentSendToAction: boolean</code> - Enable the ability for the widget document send to action.</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <tri-state-toggle formControlName="documentChangeStatus" labelUnset="Unset" labelTrue="Enabled" labelFalse="Disabled"></tri-state-toggle>
                    <div class="form-helper">
                      <div><code>documentChangeStatus: boolean</code> - Enable the ability to change status of a document in the widget (e.g., Lock, Unlock, Checkout, Undo Checkout, etc.).</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <tri-state-toggle formControlName="patent" labelUnset="Unset" labelTrue="Enabled" labelFalse="Disabled"></tri-state-toggle>
                    <div class="form-helper">
                      <div><code>patent: boolean</code> - Enable access to Patent cases in the widget. Note: access is also gated by the user's FTF access.</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <tri-state-toggle formControlName="trademark" labelUnset="Unset" labelTrue="Enabled" labelFalse="Disabled"></tri-state-toggle>
                    <div class="form-helper">
                      <div><code>trademark: boolean</code> - Enable access to Trademark cases in the widget. Note: access is also gated by the user's FTF access.</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <tri-state-toggle formControlName="matter" labelUnset="Unset" labelTrue="Enabled" labelFalse="Disabled"></tri-state-toggle>
                    <div class="form-helper">
                      <div><code>matter: boolean</code> - Enable access to Matter cases in the widget. Note: access is also gated by the user's FTF access.</div>
                    </div>
                  </div>
                </div>
                <div formGroupName="events">
                  <h3>Callback Properties (Events)</h3>
                  <div class="form-row">
                    <mat-checkbox formControlName="onLoad" class="form-control">OnLoad</mat-checkbox>
                    <div class="form-helper">
                      <div><code>onLoad(): void</code> - (Optional) Triggered when the widget finishes loading.</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <mat-checkbox formControlName="onAuth" class="form-control">OnAuth</mat-checkbox>
                    <div class="form-helper">
                      <div><code>onAuth(): void</code> - (Optional) Triggered when authentication occurs.</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <mat-checkbox formControlName="onCaseOpen" class="form-control">OnCaseOpen</mat-checkbox>
                    <div class="form-helper">
                      <div><code>onCaseOpen(item: IPCase): void</code> - (Optional) Triggered when a case is opened.</div>
                      <collapse-section [expanded]="false">
                      <div><b>IPCase:</b> Represents the details of a case. Includes the following properties:</div>
                      <ul>
                        <li><code>type: string</code> - The type of the case (e.g., 'Patent', 'Trademark', or 'Matter').</li>
                        <li><code>caseRefNum: string</code> - The reference number of the case.</li>
                        <li><code>familyNum: string</code> - The family number of the case.</li>
                        <li><code>appSerNum?: string</code> - (Optional) The application serial number of the case.</li>
                        <li><code>caseRefTitle?: string</code> - (Optional) The title of the case.</li>
                        <li><code>country?: Country</code> - (Optional) The country associated with the case.</li>
                        <li><code>filingDate?: string</code> - (Optional)  The filing date of the case. (YYYY-MM-DD)</li>
                      </ul>
                      <div><b>Country:</b> Represents the country details:</div>
                      <ul>
                        <li><code>name: string</code> - The name of the country.</li>
                      </ul>
                    </collapse-section>
                  </div>
                </div>
                <div class="form-row">
                  <mat-checkbox formControlName="onCommand" class="form-control">OnCommand</mat-checkbox>
                  <div class="form-helper">
                    <div><code>onCommand(command: string, args: []): void</code> - (Optional) Triggered when a command is executed.</div>
                    <collapse-section [expanded]="false">
                    <div><b>command:</b> A name of one of the <b>export</b> functions, representing the command being executed.</div>
                    <ul>
                      <li><code>downloadDocument</code> - Downloads a document.</li>
                      <li><code>openByCaseRefNum</code> - Opens a case by its case reference number.</li>
                      <li><code>openByAppSerNum</code> - Opens a case by its application serial number.</li>
                    </ul>
                    <div><b>args:</b> An array of arguments passed to the command.</div>
                  </collapse-section>
                </div>
              </div>
              <div class="form-row">
                <mat-checkbox formControlName="onDocumentAction" class="form-control">OnDocumentAction</mat-checkbox>
                <div class="form-helper">
                  <div><code>onDocumentAction(action: DocumentAction): void</code> - (Optional) Triggered when a document action occurs.</div>
                  <collapse-section [expanded]="false">
                  <div><b>DocumentAction:</b> Represents the "Send To" action performed on a document. Includes the following properties:</div>
                  <ul>
                    <li><code>case: IPCase</code> - The case the documents are associated with.</li>
                    <li><code>selection: DocumentSelections</code> - The documents that are being acted upon.</li>
                  </ul>
                  <div><b>DocumentSelections:</b> Represents the selections of documents within the application:</div>
                  <ul>
                    <li><code>reference: ReferenceDocument[]</code> - An array of reference documents.</li>
                    <li><code>trifold: Document[]</code> - An array of trifold documents.</li>
                  </ul>
                  <div><b>DocumentType:</b> Represents the type of a document:</div>
                  <ul>
                    <li><code>id: number</code> - The unique identifier of the document type.</li>
                    <li><code>name: string</code> - The name of the document type.</li>
                  </ul>

                  <div><b>DocumentSubType:</b> Represents the sub-type of a document:</div>
                  <ul>
                    <li><code>id: number</code> - The unique identifier of the document sub-type.</li>
                    <li><code>name: string</code> - The name of the document sub-type.</li>
                    <li><code>usptoDocTypeCode: string</code> - The USPTO document type code, if applicable. </li>
                  </ul>

                  <div><b>ReferenceType:</b> Represents the type of a reference document:</div>
                  <ul>
                    <li><code>id: number</code> - The unique identifier of the reference type.</li>
                    <li><code>name: 'Non-Patent Reference' | 'Foreign Patent' | 'US Patent'</code> - The name of the reference type.</li>
                  </ul>

                  <div><b>IPCaseRef:</b> Represents the case associated with a document:</div>
                  <ul>
                    <li><code>type: 'Patent' | 'Trademark' | 'Matter' | 'Reference'</code> - The type of the case.</li>
                    <li><code>caseRefNum: string</code> - The reference number of the case.</li>
                  </ul>

                  <!-- Use the defined types in ReferenceDocument and Document -->
                  <div><b>ReferenceDocument:</b> Represents a reference document. Includes the following properties:</div>
                  <ul>
                    <li><code>id: number</code> - The unique identifier of the document.</li>
                    <li><code>fileName: string</code> - The file name of the document.</li>
                    <li><code>refName: string</code> - The name of the Reference.  This is also considered a unique identifier for the reference in First to File.</li>
                    <li><code>refType?: ReferenceType</code> - The type of reference document.</li>
                    <li><code>downloadable: boolean</code> - Whether the document is available for download.</li>
                    <li><code>size?: number</code> - The size of the document in bytes.</li>
                    <li><code>relatedCase?: IPCaseRef</code> - The case this document is associated with.</li>
                  </ul>

                  <div><b>Document:</b> Represents the detail of a trifold document. Includes the following properties:</div>
                  <ul>
                    <li><code>id: number</code> - The unique identifier of the document.</li>
                    <li><code>fileName: string</code> - The file name of the document.</li>
                    <li><code>docDate?: string</code> - (Optional) The date of the document.</li>
                    <li><code>docType?: DocumentType</code> - (Optional) The type of the document.</li>
                    <li><code>docSubType?: DocumentSubType</code> - (Optional) The sub-type of the document.</li>
                    <li><code>downloadable: boolean</code> - Whether the document is available for download.</li>
                    <li><code>size?: number</code> - The size of the document in bytes.</li>
                    <li><code>relatedCase?: IPCaseRef</code> - The case this document is associated with.</li>
                  </ul>
                </collapse-section>
              </div>
            </div>
          </div>
        </div>
        <div class="commands-section">
          <h2>Commands</h2>
          <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [(selectedIndex)]="selectedCommandIndex">
            @if (form.get('openByCaseRefNum'); as ctrl) {
              <mat-tab label="Open By Case Ref Num" formGroupName="openByCaseRefNum">
                <div class="tabbed-action">
                  <mat-form-field>
                    <mat-label>Choose IP Type</mat-label>
                    <mat-select formControlName="type">
                      <mat-option value="All">All</mat-option>
                      <mat-option value="Patent">Patent</mat-option>
                      <mat-option value="Trademark">Trademark</mat-option>
                      <mat-option value="Matter">Matter</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="fill">
                    <mat-label>Case Reference Number</mat-label>
                    <input matInput formControlName="caseRefNum" required>
                    @if (ctrl.get('caseRefNum')?.hasError('required')) {
                      <mat-error>
                        Case Reference Number is required
                      </mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Choose sub-types</mat-label>
                    <mat-select formControlName="subTypeIds" multiple>
                      @for (subType of allSubTypes; track subType) {
                        <mat-option [value]="subType.id">{{ subType.name }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <button mat-raised-button (click)="openByCaseRefNum()" [disabled]="ctrl.invalid ||!enableWidget">Open</button>
                </div>
                <div class="form-helper">
                  <div>
                    <code>openByCaseRefNum(caseRefNum: string, type?: string, filters?: TrifoldFilters): Promise&lt;void&gt;</code> - Opens a case by its reference case number.
                  </div>
                  <collapse-section [expanded]="false">
                  <ul>
                    <li><b>caseRefNum:</b> The case reference number string of the case to open.</li>
                    <li><b>type:</b> (Optional) The type of the case: 'Patent', 'Trademark' or 'Matter'. If not provided, it will open all types of cases (based on FTF access).</li>
                    <li><b>filters:</b> (Optional) Filters to apply when opening the case.</li>
                  </ul>
                  <div><b>TrifoldFilters:</b> Optional filters that are applied to the trifold</div>
                  <ul>
                    <li><code>docSubtypeId: number[]</code> - Array of ID's that we want to filter the trifold.</li>
                  </ul>
                  <div><b>Related Callback Events:</b></div>
                  <ul>
                    <li><code>onCommand(command: string, args: []): void</code> - Triggered when a command is executed.</li>
                    <li><code>onCaseOpen(item: IPCase): void</code> - Triggered when a FTF Case Trifold is opened by either this call or manually be user.</li>
                  </ul>
                </collapse-section>
              </div>
            </mat-tab>
          }
          @if (form.get('openByAppSerNum'); as ctrl) {
            <mat-tab label="Open By App Serial Num" formGroupName="openByAppSerNum">
              <div class="tabbed-action">
                <mat-form-field>
                  <mat-label>Choose IP Type</mat-label>
                  <mat-select formControlName="type">
                    <mat-option value="All">All</mat-option>
                    <mat-option value="Patent">Patent</mat-option>
                    <mat-option value="Trademark">Trademark</mat-option>
                    <mat-option value="Matter">Matter</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>Application Serial Num.</mat-label>
                  <input matInput formControlName="appSerNum" required>
                  @if (ctrl.get('appSerNum')?.hasError('required')) {
                    <mat-error>
                      Application Serial Num. is required
                    </mat-error>
                  }
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Choose sub-types</mat-label>
                  <mat-select formControlName="subTypeIds" multiple>
                    @for (subType of allSubTypes; track subType) {
                      <mat-option [value]="subType.id">{{ subType.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <button mat-raised-button (click)="openByAppSerNum()" [disabled]="ctrl.invalid || !enableWidget">Open</button>
              </div>
              <div class="form-helper">
                <div>
                  <code>openByAppSerNum(appSerNum: string, type?: string, filters?: TrifoldFilters): Promise&lt;void&gt;</code> - Opens a case by its application serial number.
                </div>
                <collapse-section [expanded]="false">
                <ul>
                  <li><b>appSerNum:</b> The application serial number of the case to open.</li>
                  <li><b>type:</b> (Optional) The type of the case: 'Patent', 'Trademark' or 'Matter'. If not provided, it will open all types of cases (based on FTF access).</li>
                  <li><b>filters:</b> (Optional) Filters to apply when opening the case.</li>
                </ul>
                <div><b>TrifoldFilters:</b> Optional filters that are applied to the trifold</div>
                <ul>
                  <li><code>docSubtypeId: number[]</code> - Array of ID's that we want to filter the trifold.</li>
                </ul>
                <div><b>Related Callback Events:</b></div>
                <ul>
                  <li><code>onCommand(command: string, args: []): void</code> - Triggered when a command is executed.</li>
                  <li><code>onCaseOpen(item: IPCase): void</code> - Triggered when a FTF Case Trifold is opened by either this call or manually be user.</li>
                </ul>
              </collapse-section>
            </div>
          </mat-tab>
        }
        @if (form.get('download'); as ctrl) {
          <mat-tab label="Download Document." formGroupName="download">
            <div class="tabbed-action">
              <mat-form-field>
                <mat-label>Choose IP Type</mat-label>
                <mat-select formControlName="type">
                  <mat-option value="Patent">Patent</mat-option>
                  <mat-option value="Trademark">Trademark</mat-option>
                  <mat-option value="Matter">Matter</mat-option>
                  <mat-option value="Reference">Reference</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Document ID</mat-label>
                <input matInput formControlName="id" required pattern="^[0-9]*$">
                @if (ctrl.get('id')?.hasError('required')) {
                  <mat-error>
                    Document ID is required
                  </mat-error>
                }
                @if (ctrl.get('id')?.hasError('pattern')) {
                  <mat-error>
                    Document ID must be a numeric value
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Document Name</mat-label>
                <input matInput formControlName="name" required>
                @if (ctrl.get('name')?.hasError('required')) {
                  <mat-error>
                    Document Name is required
                  </mat-error>
                }
              </mat-form-field>
              <button mat-raised-button (click)="openDocument()" [disabled]="ctrl.invalid || !enableWidget"><mat-icon>download</mat-icon>Download</button>
            </div>
            <div class="form-helper">
              <div><code>downloadDocument(id: number, name: string, type: string): Promise&lt;DocumentDownload&gt;</code> - Downloads a document based on its ID, name, and type.</div>
              <collapse-section [expanded]="false">
              <ul>
                <li><b>id:</b> The unique identifier of the document to download.</li>
                <li><b>name:</b> The name of the document.</li>
                <li><b>type:</b> The type of the case the document belongs to 'Patent', 'Trademark' or 'Matter' (if a trifold document), otherwise 'Reference'.</li>
              </ul>
              <div><b>Related Callback Events:</b></div>
              <ul>
                <li><code>onCommand(command: string, args: []): void</code> - Triggered when a command is executed.</li>
                <li><code>onDocumentAction(action: DocumentAction): void</code> - Triggered when a user performs an action to send documents & ip details to hosting application.  You can use the details contained within to call <code>downloadDocument</code></li>
              </ul>
            </collapse-section>
          </div>
        </mat-tab>
      }
    </mat-tab-group>
  </div>
</form>
</div>
@if (enableWidget) {
  <div class="example-container">
    <h2>Code Example</h2>
    <pre>
      <code [highlightAuto]="widgetConfig" [languages]="['xml', 'javascript']"></code>
    </pre>
  </div>
}
</div>
<div class="bottom-container">
  <h2>Event Console</h2>
  <div #console class="column-console-container">
    @for (event of events; track event) {
      <div class="console-message">
        {{ event.timestamp }} - {{ event.type }} received {{ event.message ? ' - ' + event.message : '' }}
        @if (event.type === 'onDocumentAction') {
          <ul class="document-list">
            @for (doc of event.detail.selection.trifold; track doc; let last = $last) {
              <li>
                @if (doc.downloadable) {
                  @if (event.type === 'onDocumentAction') {
                    <a (click)="updateDownloadFormValues(doc, event.detail.case.type)">
                      <mat-icon>download</mat-icon> {{ doc.name }} {{ formatSize(doc.size) }}
                    </a>
                  }
                } @else {
                  {{ doc.name }}
                }
                {{!last ? ', ' : ''}}
              </li>
            }
            @for (doc of event.detail.selection.reference; track doc; let last = $last) {
              <li>
                @if (doc.downloadable) {
                  @if (event.type === 'onDocumentAction') {
                    <a (click)="updateDownloadFormValues(doc, 'Reference')">
                      <mat-icon>download</mat-icon> {{ doc.name }} {{ formatSize(doc.size) }}
                    </a>
                  }
                } @else {
                  {{ doc.name }}
                }
                {{!last ? ', ' : ''}}
              </li>
            }
          </ul>
        }
      </div>
    }
  </div>
</div>
</mat-drawer-content>
<mat-drawer mode="side" position="end" [opened]="enableWidget" [style.width.px]="currentWidth">
  <div class="drawer-content-col">
    <mat-toolbar>
      <div class="toolbar-buttons">
        <button mat-icon-button (click)="updateWidth(drawerContainer, 320)">
          <mat-icon fontSet="material-symbols-outlined">dock_to_left</mat-icon>
        </button>
        <button mat-icon-button (click)="updateWidth(drawerContainer, 320, 3/4)">
          <mat-icon fontSet="material-symbols-outlined">dock_to_right</mat-icon>
        </button>
      </div>
    </mat-toolbar>
    @if (isDragging) {
      <div class="drawer-drag-overlay"></div>
    }
    <div
      class="resizer"
      cdkDrag
      cdkDragLockAxis="x"
      (cdkDragStarted)="onDragStarted()"
      (cdkDragEnded)="onDragEnded(drawerContainer)"
      (cdkDragMoved)="onDragMoved($event)">
      <span class="drag-icon">⠿</span>
    </div>
    @if (enableWidget) {
      <ftf-widget #widget
        [productName]="form.get('productName')?.value"
        [orientation]="orientation"
        [featureFlags]="featureFlags"
        [events]="form.get('events')?.value"
        (documentAction)="onDocumentAction($event)" (widgetLoad)="onLoad()" (authAction)="onAuth()"
      (caseOpen)="onCaseOpen($event)" (commandAction)="onCommand($event)"></ftf-widget>
    }
  </div>
</mat-drawer>
</mat-drawer-container>
</div>
</div>